import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, LOCALE_ID, provideAppInitializer } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { InitService } from './core/services/init.service';
import { lastValueFrom } from 'rxjs';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { GlobalErrorHandler } from './core/handlers/global-error-handler';
import { NgxPermissionsModule } from 'ngx-permissions';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxEditorModule } from 'ngx-editor';
import { provideNgxMask } from 'ngx-mask';

function initializeApp(initService: InitService) {
  return () =>
    lastValueFrom(initService.init()).finally(() => {
      if (typeof document !== 'undefined') {
        const splash = document.getElementById('initial-splash');
        if (splash) {
          splash.remove();
        }
      }
    });
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    importProvidersFrom(NgxEditorModule),
    importProvidersFrom(NgxSpinnerModule.forRoot({ type: 'line-scale' })),
    importProvidersFrom(NgxDaterangepickerMd.forRoot({
      separator: ' - ',
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      clearLabel: 'Limpar',
      customRangeLabel: 'Intervalo Personalizado',
      format: 'DD/MM/YYYY'
    })),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideClientHydration(), 
    provideHttpClient(
      withInterceptors([authInterceptor, errorInterceptor])
    ),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    provideAppInitializer(() => {
        const initializerFn = (initializeApp)(inject(InitService));
        return initializerFn();
      }), provideCharts(withDefaultRegisterables()),
    provideAnimations(),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    importProvidersFrom(MatNativeDateModule),
    provideNgxMask(),
]
};
